import React from "react";
import { isBefore } from "date-fns";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import formatDate, { parseDate } from "../../utils/formatDate";

type Props = {
  classes?: any;
  dueDate: Date | number;
};

type State = {};

const styles = (theme: Theme) =>
  createStyles({
    overdue: {
      color: theme.palette.secondary.main
    }
  });

class ResponseDueIcon extends React.Component<Props, State> {
  render() {
    const { classes, dueDate } = this.props;
    const overdue = isBefore(parseDate(dueDate), Date.now());
    const relativeDate = formatDate.relative(dueDate);
    if (overdue) {
      return <span className={classes.overdue}>{relativeDate}</span>;
    }
    return <span>{relativeDate}</span>;
  }
}

const styled = withStyles(styles)(ResponseDueIcon);
export { styled as ResponseDueIcon };
